import React from "react";
import { Card, CardContent, Box, Typography, Button } from "@mui/material";

const MiniBetCard = ({
  minibet,
  hasUserMiniBet,
  openMiniBetModal,
  getSportIcon,
  formatDate,
  renderSettingsIcon,
  getUserMiniBetAmount,
  getUserMiniBetResult,
}) => {
  const userResult = getUserMiniBetResult(minibet.id);
  const isFullWidth = minibet.odds.some((odd) => odd.label.length > 10);

  // 🔹 URL d'image optionnelle (aucune image par défaut)
  const miniImageUrl =
    minibet.imageMiniBetUrl || minibet.imageBetUrl || minibet.imageUrl || "";

  return (
    <Card
      key={minibet.id}
      sx={{
        elevation: 2,
        borderRadius: "25px",
        marginBottom: "15px",
      }}>
      <CardContent sx={{ padding: "0", margin: "0" }}>
        <Box
          sx={{
            backgroundColor: "rgba(90,20,121,254)",
            position: "relative",
            padding: "10px",
          }}>
          <Box
            sx={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              display: "flex",
              alignItems: "center",
            }}>
            {minibet.sportCategory === "octopearl" ? (
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "8px",
                }}>
                OctoPearl
              </span>
            ) : minibet.sportCategory === "poulparty" ? (
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "8px",
                }}>
                PoulParty
              </span>
            ) : (
              getSportIcon(minibet.sportCategory)
            )}
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: "white",
              fontWeight: "bold",
              textAlign: "center",
            }}>
            {formatDate(minibet.date)}
          </Typography>
          {renderSettingsIcon(minibet.id, "mini")}
        </Box>

        {/* 🔹 Image du mini pari (affichée seulement si une URL existe) */}
        {miniImageUrl ? (
          <img
            src={miniImageUrl}
            alt={`Mini pari - ${minibet.title || ""}`}
            loading="lazy"
            decoding="async"
            onError={(e) => {
              // si l'URL est cassée on masque l'image (pas d'image par défaut)
              e.currentTarget.style.display = "none";
            }}
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
              display: "block",
            }}
          />
        ) : null}

        <Box sx={{ margin: "20px 20px 0px 20px" }}>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{
              color: "rgba(90,20,121,254)",
              fontWeight: "bold",
              lineHeight: 1,
            }}>
            {minibet.title}
          </Typography>

          {/* 🔹 Affichage du résultat si les gains ont été distribués */}
          {minibet.distributeWinningDone && userResult ? (
            <Box sx={{ marginTop: 2, textAlign: "left" }}>
              {userResult.status === "gagné" ? (
                <Typography
                  variant="body2"
                  sx={{ color: "green", fontWeight: "bold" }}>
                  Vous avez gagné 🤙{userResult.winnings}
                </Typography>
              ) : userResult.status === "perdu" ? (
                <Typography
                  variant="body2"
                  sx={{ color: "red", fontWeight: "bold" }}>
                  Vous avez perdu 🤙{userResult.lostAmount}
                </Typography>
              ) : null}
            </Box>
          ) : !minibet.distributeWinningDone &&
            minibet.bettingStatus !== "termine" ? (
            <Box>
              {!hasUserMiniBet(minibet.id) ? (
                <Box
                  display="flex"
                  flexDirection="row"
                  flexWrap="wrap"
                  gap={1}
                  sx={{
                    marginTop: 2,
                    justifyContent: "space-between",
                  }}>
                  {minibet.odds.map((odd, idx) => (
                    <Button
                      key={idx}
                      variant="contained"
                      onClick={() =>
                        openMiniBetModal(minibet.id, odd.label, odd.value)
                      }
                      sx={{
                        flex: isFullWidth ? "1 1 100%" : "1 1 calc(50% - 4px)",
                        maxWidth: isFullWidth ? "100%" : "calc(50% - 4px)",
                        backgroundColor: "rgba(225, 191, 228, 255)",
                        padding: "0px",
                        boxSizing: "border-box",
                        borderRadius: "15px",
                      }}>
                      <Box
                        textAlign="center"
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                          padding: "4px",
                        }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            maxWidth: "90%",
                            fontSize: "0.7rem",
                          }}>
                          {odd.label}
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            color: "rgba(90,20,121,254)",
                            fontWeight: "bold",
                          }}>
                          {odd.value}
                        </Typography>
                      </Box>
                    </Button>
                  ))}
                </Box>
              ) : (
                <Typography color="text.secondary" sx={{ marginTop: 2 }}>
                  Montant parié : {getUserMiniBetAmount(minibet.id)} 🤙
                </Typography>
              )}
            </Box>
          ) : (
            <Typography color="text.secondary" sx={{ marginTop: 1 }}>
              {minibet.bettingStatus === "terminé"
                ? "Mini pari fini, découvre tes gains !"
                : "Les mises sont fermées pour ce mini pari."}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default MiniBetCard;
